import {useAppType} from "./util/AppVersionProvider.tsx";
import {AnalysisProcess} from "./analysis-process/AnalysisProcess.tsx";
import {CustomerAnalysisProcess} from "./customer-analysis-process/CustomerAnalysisProcess.tsx";

export function AppSwitcher() {
    const app = useAppType()
    if(app === "SUPPORT_ASSISTED") {
        return <AnalysisProcess />
    } else if (app === "CUSTOMER_FACING") {
        return <CustomerAnalysisProcess />
    } else {
        return <div>Hllo</div>
    }
}